module.exports = __webpack_public_path__ + "img/2.-季节观赏法-夏季-古流苏（马晓燕-摄）.530724ea.jpg";